import React from 'react';
import {
  FormControl,
  FormControlProps,
  InputBaseProps,
  makeStyles,
  TextFieldProps,
} from '@material-ui/core';
import { BaseInputLabel } from './BaseInputLabel/BaseInputLabel';
import { BaseInput } from './BaseInput/BaseInput';
import { BaseHelperText } from './BaseHelperText/BaseHelperText';
import { capitalizeFirstLetter } from '../../../utils/helpers';
import clsx from 'clsx';

export type TLabelFieldType = string | number | React.ElementType;

export type PBaseTextField = Pick<TextFieldProps, 'InputProps' | 'size'> &
  FormControlProps &
  InputBaseProps & {
    errorText?: string;
    label?: TLabelFieldType;
    fullWidth?: boolean;
    inputInnerProps?: any; // Attributes applied to the input element.
    helperText?: string;
    absoluteHelperPosition?: boolean;
  };

const useStyles = makeStyles(() => ({
  label: {
    marginBottom: '8px',
  },
  // @ts-ignore
  inputClass: ({ size }) => ({
    minHeight: size === 'small' ? '35px' : '45px',
    '& input': {
      padding: size === 'small' ? '5px 10px' : '10px 15px',
    },
  }),
}));

export const BaseTextField: React.FC<PBaseTextField> = (props) => {
  const {
    value,
    label,
    placeholder,
    errorText,
    onClick,
    InputProps = {},
    inputInnerProps = {},
    fullWidth,
    style = {},
    error,
    helperText,
    size,
    className,
    absoluteHelperPosition,
    ...otherProps
  } = props;
  const classes = useStyles({ size });
  const helperStyles: any = {
    position: absoluteHelperPosition ? 'absolute' : 'static',
    top: '100%',
  };

  return (
    <FormControl
      error={Boolean(errorText || error)}
      onClick={onClick}
      fullWidth={fullWidth}
      style={style}
      className={className}
    >
      {label && (
        <BaseInputLabel className={classes.label}>{label}</BaseInputLabel>
      )}
      <BaseInput
        value={value}
        placeholder={placeholder}
        inputProps={inputInnerProps}
        {...InputProps}
        {...otherProps}
        className={clsx(classes.inputClass, InputProps.className)}
      />
      {errorText && (
        <BaseHelperText style={helperStyles}>
          {capitalizeFirstLetter(errorText)}
        </BaseHelperText>
      )}

      {error && helperText && (
        <BaseHelperText>{capitalizeFirstLetter(helperText)}</BaseHelperText>
      )}
    </FormControl>
  );
};

export const MBaseTextField = React.memo(BaseTextField);

// const StyledTextField = withStyles((theme) => ({
//   root: {
//     '& .MuiInputBase-root': {
//       height: '45px',
//     },
//     '& .MuiInputBase-input': {
//       padding: '0 15px',
//     },
//     '& fieldset': {
//       border: '1px solid #9EA8AB',
//     },
//     '& .MuiOutlinedInput-root': {
//       borderRadius: '2px',
//       '&.Mui-focused fieldset': {
//         borderColor: theme.palette.primary.main,
//         borderWidth: '1px',
//       },
//     },
//   },
// }))(TextField);
